
import {defineComponent, onMounted, inject, ref, watch, reactive} from "vue";
import {
    getMountingsBrandTable,
    postEditMountingsBrand,
    postAddMountingsBrand,
    postDeleteMountingsBrand, permissionList,
} from "@/api/http";
type brandParameter = {
    page: number;
    pagesize: number;
    status?: number;
    search?: string;
};
export default defineComponent({
    name: "Brand",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["配件品牌"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            roleList = ref({} as any),
            tableData = ref([]),
            loading = ref(true),
            tableStatus = ref(-1),
            status = ref(-1),
            search = ref(""),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增分类"),
            formRef = ref(null),
            form = ref({
                name: "",
                sort: 1,
                id: 0,
            }),
            filterVariable = reactive({
                status:null,
                search:"",
                page:1,
                pagesize:10
            }),
            isEdit = ref(false);
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'brand',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let data = {
                    ...filterVariable,
                    page: currentPage.value,
                    pagesize: pageSize.value
                };
                getMountingsBrandTable(data).then((res: any) => {
                    if (res.status == 200) {
                        tableData.value = res.content.list;
                        loading.value = false;
                        total.value = res.content.count;
                    }
                });
            },
            columnChange = (item: any, type: boolean): void => {
                if (type) {
                    dialogTitle.value = "编辑分类";
                    isEdit.value = true;
                    dialogFormVisible.value = true;
                    form.value.name = item.name;
                    form.value.sort = item.sort;
                    form.value.id = item.id;
                } else {
                    postDeleteMountingsBrand({ id: item.id }).then((res) =>
                        getTableData()
                    );
                }
            },
            inputChange = (e: string): void => {
                getTableData();
            },
            selectChange = (e: number): void => {
                getTableData();
            },
            submitForm = () => {
                (formRef.value as any).validate(async (valid: boolean) => {
                    if (valid) {
                        if (isEdit.value) {
                            await postEditMountingsBrand(form.value).then(
                                (res) =>
                                    (dialogFormVisible.value =
                                        res.status != 202)
                            );
                        } else {
                            let data = {
                                name: form.value.name,
                                sort: form.value.sort,
                            };
                            await postAddMountingsBrand(data).then(
                                (res) =>
                                    (dialogFormVisible.value =
                                        res.status != 202)
                            );
                        }
                        !dialogFormVisible.value && getTableData();
                    }
                });
            };
        onMounted(() => {
            getTableData();
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                (formRef.value as any).resetFields();
                form.value = {
                    name: "",
                    sort: 1,
                    id: 0,
                };
                isEdit.value = false;
                dialogTitle.value = "新增分类";
                (formRef.value as any).resetFields();
            }
        });

        return {
            headClass,
            pageSize,
            currentPage,
            total,
            tableData,
            tableStatus,
            loading,
            search,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            isEdit,
            handleSizeChange,
            handleCurrentChange,
            columnChange,
            inputChange,
            selectChange,
            submitForm,
            filterVariable,
            roleList
        };
    },
});
